import colors from 'assets/theme/base/colors';
import typography from 'assets/theme/base/typography';
import pxToRem from 'assets/theme/function/px-to-rem';
import borders from 'assets/theme/base/borders';
import rgba from 'assets/theme/function/rgba';
import { breakpoints } from 'assets/theme/base/breakpoints';

const { common, primary, success, action } = colors;
const { fontWeightBold, fontWeightMedium, size } = typography;
const { borderRadius } = borders;

const contained = {
    base: {
        '&:hover': {
            opacity: 0.8,
        },
    },

    small: {
        padding: `${pxToRem(3)} ${pxToRem(11)}`,
        fontSize: size.xs,
        fontWeight: fontWeightMedium,
    },

    medium: {
        padding: `${pxToRem(10)} ${pxToRem(22)}`,
        borderRadius: borderRadius.md,
        fontSize: size.md,
        fontWeight: fontWeightMedium,

        [breakpoints.down('md')]: {
            //padding: `${pxToRem(12)} ${pxToRem(18)}`,
            fontSize: size.sm,
        },

        [breakpoints.down('sm')]: {
            padding: `${pxToRem(12)} ${pxToRem(10)}`,
            fontSize: size.xs,
        },

        '& .MuiButton-endIcon': {
            [breakpoints.down('md')]: {
                marginLeft: pxToRem(3),
            },
        },
    },

    large: {
        padding: `${pxToRem(12)} ${pxToRem(22)}`,
        borderRadius: borderRadius.md,
        fontSize: size.xl,
        fontWeight: fontWeightBold,

        [breakpoints.down('md')]: {
            fontSize: size.lg,
        },

        [breakpoints.down('sm')]: {
            fontSize: size.md,
        },
    },

    primary: {
        backgroundColor: primary.light,
        color: common.white,

        '&:disabled': {
            backgroundColor: rgba(primary.main, 0.5),
            color: action.light,
        },

        /*[breakpoints.down('sm')]: {
            backgroundColor: 'red',
        },*/

        /*'&.MuiLoadingButton-loading': {
            color: action.light,
        },*/
    },

    info: {
        backgroundColor: rgba(colors.grey['800'], 0.8),
    },

    secondary: {
        backgroundColor: success.main,
        color: common.white,

        '&:disabled': {
            backgroundColor: rgba(success.main, 0.5),
            color: action.light,
        },

        /*'&.MuiLoadingButton-loading': {
            color: action.light,
        },*/

        /*'&:hover': {
		   backgroundColor: primary.main,
	   },

	   '&:focus:not(:hover)': {
            backgroundColor: primary.main,
        },*/
    },

    error: {
        /*backgroundColor: error.light,
        color: error.main,
        boxShadow: 'none',

        '&:hover': {
            backgroundColor: error.light,
            color: error.main,
        },*/
    },
};

export default contained;
